import React from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar as CalendarIcon, ChevronLeft, ChevronRight, Calculator } from 'lucide-react';
import { Button } from '../../../components/ui/button';

interface CalendarHeaderProps {
    currentDate: Date;
    onNext: () => void;
    onPrev: () => void;
    onToday: () => void;
}

export const CalendarHeader: React.FC<CalendarHeaderProps> = ({ currentDate, onNext, onPrev, onToday }) => {
    const { t, i18n } = useTranslation('common');

    // Capitalize first letter of month
    const formatMonth = (date: Date) => {
        const str = date.toLocaleString(i18n.language, { month: 'long', year: 'numeric' });
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    return (
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
            <div className="flex items-center gap-4">
                <div className="p-3 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-lg shadow-lg text-white">
                    <CalendarIcon size={32} />
                </div>
                <div>
                    <h1 className="text-3xl font-bold text-gray-900 tracking-tight">
                        {t('calendar.header.title')}
                    </h1>
                    <p className="text-gray-500 mt-1">
                        {t('calendar.header.subtitle')}
                    </p>
                </div>
            </div>

            <div className="flex items-center gap-2 bg-white p-1 rounded-lg border shadow-sm">
                <Button variant="ghost" size="icon" onClick={onPrev}>
                    <ChevronLeft className="h-4 w-4" />
                </Button>
                <div className="px-4 font-semibold min-w-[140px] text-center">
                    {formatMonth(currentDate)}
                </div>
                <Button variant="ghost" size="icon" onClick={onNext}>
                    <ChevronRight className="h-4 w-4" />
                </Button>
                <div className="w-[1px] h-6 bg-gray-200 mx-1"></div>
                <Button variant="ghost" size="sm" onClick={onToday} className="text-xs font-medium">
                    {t('profile.time.today')}
                </Button>
            </div>
        </div>
    );
};
